import RadioBox2 from "../forms/RadioBox2";
import React from "react";


export default props => {
    const {reload, facet} = props
    return <div className="additionalBtnsFlex">
        {facet.map(mm => <RadioBox2 func={reload} key={mm} name="processingValue" value={mm}
                              id={mm + "proc"} txt={mm}/>)}
    </div>
}
